/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
//@import BaseMoserObject (loadtime) // superclass

/**
 * Describes a change in the model.
 */
export default class Notification extends BaseMoserObject{

	/**
	 * The notification type indicating that a value has been inserted into a list-based feature of the notifier.
	 */
	static ADD = 1;

	/**
	 * The notification type indicating that a value has been removed from a list-based feature of the notifier.
	 */
	static REMOVE = 2;

	/**
	 * The notification type indicating that a value has been set in the notifier.
	 */
	static SET = 3;

	/**
	 * The notification type indicating that the notifier has been created.
	 */
	static CREATE = 4;

	/**
	 * Indicates that position information is not applicable to the notification.
	 */
	static NO_POSITION = -1;

	type = 0;

	notifier = null;

	featureID = 0;

	oldValue = null;

	newValue = null;

	position = 0;



	/**
	 * Create a new notification.
	 * @param {int} type the type of change that has occurred
	 * @param {INotifier} notifier the object that was changed
	 * @param {int} featureID the ID of the feature that was changed in the notifier
	 * @param {BaseMoserObject} oldValue the old value of the feature before the change, will be <code>null</code> for  {@link #4}  and  {@link #1}  notifications. For {@link #2} , the old value will be the item that was removed.
	 * @param {BaseMoserObject} newValue the new value of the feature after the change, will be <code>null</code> for  {@link #4}  and  {@link #2}  notifications. For {@link #1} , the new value will be the item that was added.
	 * @param {int} position the position at which an item was added or removed, for list-based features. Use  {@link #-1}  when not applicable.
	 */
	constructor(type, notifier, featureID, oldValue, newValue, position) {
		super();
		this.type = type;
		this.notifier = notifier;
		this.featureID = featureID;
		this.oldValue = oldValue;
		this.newValue = newValue;
		this.position = position;
	}

	/**
	 * Gets the type of change that has occurred.
	 * @return {int}  the type
	 */
	getType() {
		return this.type;
	}

	/**
	 * Gets the object that was changed.
	 * @return {BaseMoserObject}  the notifier
	 */
	getNotifier() {
		return this.notifier;
	}

	/**
	 * Gets the ID of the feature that was changed in the notifier.
	 * @return {int}  the feature ID
	 */
	getFeatureID() {
		return this.featureID;
	}

	/**
	 * Gets the old value of the feature before the change, will be <code>null</code> for  {@link #4}  and  {@link #1}  notifications. For  {@link #2} , the old value will be the item that was removed.
	 * @return {BaseMoserObject}  the old value
	 */
	getOldValue() {
		return this.oldValue;
	}

	/**
	 * Gets the new value of the feature after the change, will be <code>null</code> for  {@link #4}  and  {@link #2}  notifications. For  {@link #1} , the new value will be the item that was added.
	 * @return {BaseMoserObject}  the new value
	 */
	getNewValue() {
		return this.newValue;
	}

	/**
	 * Gets the position at which an item was added or removed, for list-based features. Will be  {@link #-1}  when not applicable.
	 * @return {int}  the position
	 */
	getPosition() {
		return this.position;
	}
}


// WEBPACK FOOTER //
// ./src/generated/Notification.js